import { render, staticRenderFns } from "./TrabalhoEscravo.vue?vue&type=template&id=2218f3a0&lang=pug"
import script from "./TrabalhoEscravo.vue?vue&type=script&lang=js"
export * from "./TrabalhoEscravo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports